module.exports = __webpack_public_path__ + "media/images/official/top_homesimage_arrow_left-942bfe606cbf9222204a7ca55f4956ea.svg";